import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { LoginService } from 'src/app/services/login.service';
import { ToolbarItemComponent } from 'src/app/toolbar/toolbar-item/toolbar-item.component';

@Component({
  selector: 'app-login',
  imports: [
    IconModule,
    TextModule,
    PipesModule,
    ToolbarItemComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private readonly loginService = inject(LoginService);

  get loginHref(): string {
    return `${environment.authUrl}checklogin?next_url=${window.location.href}`;
  }

  get logoutHref(): string {
    return `${environment.authUrl}access/logoutandredirect?next_url=${window.location.href}`;
  }

  tokenVerified = this.loginService.tokenVerified;
  loggedIn = this.loginService.loggedIn;

  showLogin(): boolean {
    return this.tokenVerified() && !this.loggedIn();
  }

  showLogout(): boolean {
    return this.tokenVerified() && this.loggedIn();
  }
}
